import Vue from 'vue';

const clickOutsideEvent: null | (() => void) = null;

export const closable = Vue.directive('closable', {
	bind(el, binding, vnode) {
		const vm = vnode.context;
		const callback = binding.value;

		const clickOutsideEvent = function(event: Event) {
			if (!(el == event.target || el.contains(event.target as HTMLElement))) {
				return callback.call(vm, event);
			}
		};
		document.body.addEventListener('click', clickOutsideEvent);
	},
	unbind(el) {
		if (clickOutsideEvent) document.body.removeEventListener('click', clickOutsideEvent);
	},
});
